module.exports = __webpack_public_path__ + "assets/images/cockpit/active/btn_audio_off_ru.png";